import { BookablePeriod } from '@mews-commander/data-access';
import { WithBookablePeriod } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const feeExtentTimeUnitBookablePeriodTextKeyMap: Record<BookablePeriod, Mews.TextKey> = {
    Day: TextKey.CancellationFeeExtentDay,
    Hour: TextKey.CancellationFeeExtentHour,
    Month: TextKey.CancellationFeeExtentMonth,
    Night: TextKey.CancellationFeeExtentNight,
};

export const LocalizedCancellationPolicyBookablePeriod = ({ bookablePeriod }: WithBookablePeriod) =>
    lt(feeExtentTimeUnitBookablePeriodTextKeyMap[bookablePeriod]);
